// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__sohneBreit_7492e8', '__sohneBreit_Fallback_7492e8'"},"className":"__className_7492e8","variable":"__variable_7492e8"};